import { useState, useEffect } from "react";
import { Container, Row, Col, Form, Button, Alert } from "react-bootstrap";

const Latpay3dFlow = () => {
    const [formData, setFormData] = useState({
        accountid: "test_Tstvalitor_3d",
        firstname: "thirlok",
        lastname: "shankar",
        phone: "1234512345",
        email: "thirlok@lpsmail.com",
        reference: "lpstest123",
        currency: "GBP",
        amount: "0.10",
        purchasesummary: "Ecomm purchase list",
        _3dreq: "y",
        name: "thirlok",
        pan: "4921816852872867",
        exp: "01/27",
        cvc: "300"
    });

    // Flow State
    const [loading, setLoading] = useState(false);
    const [logRequest, setLogRequest] = useState("");
    const [logResponse, setLogResponse] = useState("");
    const [error, setError] = useState({});
    const [successMsg, setSuccessMsg] = useState("");
    const [errorMsg, setErrorMsg] = useState("");

    // 3D Secure State
    const [enrollmentData, setEnrollmentData] = useState(null);
    const [step2Data, setStep2Data] = useState({
        pares: "",
        gatewayreference: ""
    });

    // -------------------------------------------------------------
    // EVENT LISTENER: Listen for PARes from the TermURL iframe
    // -------------------------------------------------------------
    useEffect(() => {
        const handleIframeMessage = (event) => {
            // NOTE: In production, always verify event.origin for security!
            // Example: if (event.origin !== "https://your-trusted-domain.com") return;

            if (event.data && event.data.type === '3DS_COMPLETE' && event.data.pares) {
                setStep2Data((prev) => ({ ...prev, pares: event.data.pares }));
            }
        };

        window.addEventListener('message', handleIframeMessage);
        return () => window.removeEventListener('message', handleIframeMessage);
    }, []);

    // -------------------------------------------------------------
    // AUTO-SUBMIT: Triggers automatically when enrollmentData is set
    // -------------------------------------------------------------
    useEffect(() => {
        if (enrollmentData) {
            // Dynamically create a form and submit it into the iframe
            const form = document.createElement('form');
            form.method = 'POST';
            form.action = enrollmentData.VBV_URL;
            form.target = 'acsIframe'; // Targets the iframe rendered below
            form.acceptCharset = 'UTF-8';

            const mdInput = document.createElement('input');
            mdInput.type = 'hidden';
            mdInput.name = 'MD';
            mdInput.value = `TransactionId=${enrollmentData.gatewayreference}&Merchant_ref_number=${formData.reference}&BackToMerchantURL=grp77_LPS&BackToMerchantParams=LPSTest`;
            form.appendChild(mdInput);

            const pareqInput = document.createElement('input');
            pareqInput.type = 'hidden';
            pareqInput.name = 'PaReq';
            pareqInput.value = enrollmentData.PAReq;
            form.appendChild(pareqInput);

            const termUrlInput = document.createElement('input');
            termUrlInput.type = 'hidden';
            termUrlInput.name = 'TermURL';
            termUrlInput.value = 'https://l4p2s7p2r4o3c9e3ss.com/3dSecurity/3dTermUrl.aspx';
            form.appendChild(termUrlInput);

            document.body.appendChild(form);
            form.submit();
            document.body.removeChild(form);
        }
    }, [enrollmentData, formData.reference]);


    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData((prev) => ({ ...prev, [name]: value }));
        if (error[name]) setError({ ...error, [name]: '' });
    };

    const handleCardDetailsChange = (e) => {
        let { name, value } = e.target;

        if (name === "pan") {
            // Remove all non-digits (blocks letters/symbols)
            let rawValue = value.replace(/\D/g, '');
            // Limit to 16 digits
            if (rawValue.length > 16) rawValue = rawValue.substring(0, 16);
            setFormData(prev => ({ ...prev, pan: rawValue }));
        }
        else if (name === "exp") {
            // Remove all non-digits
            let rawValue = value.replace(/\D/g, '');
            // Limit to 4 digits total
            if (rawValue.length > 4) rawValue = rawValue.substring(0, 4);

            // Auto-insert the slash after the month
            let formattedValue = rawValue;
            if (rawValue.length > 2) {
                formattedValue = `${rawValue.substring(0, 2)}/${rawValue.substring(2)}`;
            }
            setFormData(prev => ({ ...prev, exp: formattedValue }));
        }
        else if (name === "cvc") {
            // Remove all non-digits
            let rawValue = value.replace(/\D/g, '');
            // Limit to 4 digits (Amex is 4, Visa/MC is 3)
            if (rawValue.length > 4) rawValue = rawValue.substring(0, 4);
            setFormData(prev => ({ ...prev, cvc: rawValue }));
        }

        // Clear validation errors if user starts typing
        if (error[name]) setError({ ...error, [name]: '' });
    };

    const handleStep2Change = (e) => {
        const { name, value } = e.target;
        setStep2Data((prev) => ({ ...prev, [name]: value }));
    };

    // -------------------------------------------------------------
    // STEP 1: INITIATE REQUEST
    // -------------------------------------------------------------
    const handleSubmitStep1 = async () => {
        setLoading(true);
        setSuccessMsg("");
        setErrorMsg("");
        setEnrollmentData(null);

        const payload = {
            accountid: formData.accountid,
            authkey: "289360a7479d37ff1bd075d3f4ce7575acc9a5c4d982f1859c19137ac533e65ed395e3bb997d2fb299ad15fee0a1a47f9873e370dfa91c77a018496595b9aee2",
            consumer: { firstname: formData.firstname, lastname: formData.lastname, phone: formData.phone, email: formData.email },
            order: { reference: formData.reference, currency: formData.currency, amount: formData.amount, purchasesummary: formData.purchasesummary },
            callback_params: { param1: "value1", param2: "value2", param3: "value3", param4: "value4", param5: "value5" },
            _3drequest: { _3dcheck: formData._3dreq },
            billing: {
                type: "card",
                card: { name: formData.name, pan: formData.pan, exp: formData.exp, cvc: formData.cvc },
                address: { line1: "Southbank House", line2: "", city: "London", state: "", country: "GB", zipcode: "SE1" },
                fees: { processingfee: "0.00", surcharge: "0.00" }
            }
        };

        setLogRequest(JSON.stringify(payload, null, 2));

        try {
            const response = await fetch('https://us-central1-gatewaypanel-test.cloudfunctions.net/initiatePos3DSecure', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
                body: JSON.stringify(payload)
            });

            const responseText = await response.text();
            let jsonResponse;
            try { jsonResponse = JSON.parse(responseText); } catch { jsonResponse = responseText; }

            setLogResponse(JSON.stringify(jsonResponse, null, 2));

            if (jsonResponse?.status?.errordesc === "3d2initiated") {
                const enrollData = jsonResponse.billing?._3dresponse?.enrollmentdata;
                if (enrollData) {
                    setEnrollmentData(enrollData);
                    setStep2Data((prev) => ({ ...prev, gatewayreference: enrollData.gatewayreference }));
                }
            } else {
                setErrorMsg("Request completed, but no 3D Secure challenge was initiated.");
            }
        } catch (err) {
            setErrorMsg(`Failed to initiate request: ${err.message}`);
        } finally {
            setLoading(false);
        }
    };


    // -------------------------------------------------------------
    // STEP 3: FINAL AUTH (SHA-512 + API CALL)
    // -------------------------------------------------------------
    const generateSHA512 = async (text) => {
        const encoder = new TextEncoder();
        const data = encoder.encode(text);
        const hashBuffer = await crypto.subtle.digest('SHA-512', data);
        const hashArray = Array.from(new Uint8Array(hashBuffer));
        return hashArray.map(b => b.toString(16).padStart(2, '0')).join('');
    };

    const handleSubmitStep3 = async () => {
        if (!step2Data.pares) {
            setErrorMsg("Please provide the PARes string.");
            window.scrollTo({ top: 0, behavior: 'smooth' });
            return;
        }

        setLoading(true);
        setSuccessMsg("");
        setErrorMsg("");

        try {
            const accountkey = "test";
            const combinedString = `${step2Data.gatewayreference}${formData.accountid}${formData.reference}${accountkey}`;
            const authkeyHash = await generateSHA512(combinedString);

            const finalPayload = {
                accountid: formData.accountid,
                authkey: authkeyHash,
                reference: formData.reference,
                pares: step2Data.pares,
                gatewayreference: step2Data.gatewayreference
            };

            setLogRequest(JSON.stringify(finalPayload, null, 2));

            const response = await fetch('https://us-central1-gatewaypanel-test.cloudfunctions.net/completePos3DSecure', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
                body: JSON.stringify(finalPayload)
            });

            const responseText = await response.text();
            let jsonResponse;
            try { jsonResponse = JSON.parse(responseText); } catch { jsonResponse = responseText; }

            setLogResponse(JSON.stringify(jsonResponse, null, 2));

            if (jsonResponse?.status?.statuscode === "0") {
                setSuccessMsg(`Transaction Successful! Transaction ID: ${jsonResponse.transactionid || 'N/A'}`);
            } else {
                setErrorMsg("Final authorization failed or returned a non-zero status.");
            }

        } catch (err) {
            setErrorMsg(`Failed final auth request: ${err.message}`);
        } finally {
            setLoading(false);
            // Auto-scroll back to the top of the page smoothly
            window.scrollTo({ top: 0, behavior: 'smooth' });
        }
    };

    return (
        <div style={{ position: "relative", minHeight: "100vh", overflow: 'hidden' }}>
            <Container fluid style={{ padding: 0 }}>
                {/* HERO BANNER */}
                <Row>
                    <Col
                        style={{
                            backgroundColor: "#00a1be", height: "143px", display: "flex", alignItems: "flex-end",
                            padding: "10px", justifyContent: "center", position: "relative", overflow: "hidden",
                        }}
                    >
                        <div style={{ position: "absolute", top: 0, left: 0, right: 0, bottom: 0, opacity: 0.5, backgroundImage: 'url(https://latpay.com/wp-content/themes/enfold/images/background-images/dots-mini-light.png)', backgroundRepeat: 'repeat', zIndex: 1 }}></div>
                        <h1 style={{ color: "whitesmoke", fontSize: "50px", textAlign: "center", position: "relative", zIndex: 2 }}>
                            Latpay - POS 3D Secure WorkFlow
                        </h1>
                    </Col>
                </Row>

                <Container style={{ marginTop: "40px", marginBottom: "75px" }}>

                    {/* ALERTS */}
                    {successMsg && (
                        <Alert variant="success" onClose={() => setSuccessMsg("")} dismissible>
                            <Alert.Heading>Payment Authorized!</Alert.Heading>
                            <p className="mb-0">{successMsg}</p>
                        </Alert>
                    )}
                    {errorMsg && (
                        <Alert variant="danger" onClose={() => setErrorMsg("")} dismissible>
                            <p className="mb-0">{errorMsg}</p>
                        </Alert>
                    )}

                    {/* TOP FORM SECTION (STEP 1) */}
                    <div style={{ border: "1px solid #ccc", borderRadius: "5px", padding: "20px", margin: "20px 0" }}>
                        <Row>
                            <Col>
                                <div style={{ textAlign: "left", marginBottom: "30px" }}>
                                    <p style={{ fontWeight: "bold", fontSize: "24px", fontFamily: "HelveticaNeue, sans-serif", color: "#253370" }}>
                                        1. Process 3D Secure Request
                                    </p>
                                </div>
                            </Col>
                        </Row>

                        <Row>
                            <Col md={3}>
                                <div style={{ textAlign: "left", marginBottom: "25px" }}>
                                    <Form.Label style={{ fontWeight: "bold", fontSize: "12px", color: "#666666" }}>Account ID</Form.Label>
                                    {/* <Form.Control type="text" value={formData.accountid} name="accountid" onChange={handleChange} style={{ fontSize: "12px" }} /> */}
                                    <Form.Control type="text" value={formData.accountid} name="accountid" disabled style={{ fontSize: "12px" }} />
                                </div>
                            </Col>
                            <Col md={3}>
                                <div style={{ textAlign: "left", marginBottom: "25px" }}>
                                    <Form.Label style={{ fontWeight: "bold", fontSize: "12px", color: "#666666" }}>Reference</Form.Label>
                                    <Form.Control type="text" value={formData.reference} name="reference" disabled style={{ fontSize: "12px" }} />
                                </div>
                            </Col>
                            <Col md={3}>
                                <div style={{ textAlign: "left", marginBottom: "25px" }}>
                                    <Form.Label style={{ fontWeight: "bold", fontSize: "12px", color: "#666666" }}>Currency</Form.Label>
                                    <Form.Control type="text" value={formData.currency} name="currency" disabled style={{ fontSize: "12px" }} />
                                </div>
                            </Col>
                            <Col md={3}>
                                <div style={{ textAlign: "left", marginBottom: "25px" }}>
                                    <Form.Label style={{ fontWeight: "bold", fontSize: "12px", color: "#666666" }}>Amount</Form.Label>
                                    <Form.Control type="text" value={formData.amount} name="amount" disabled style={{ fontSize: "12px" }} />
                                </div>
                            </Col>
                        </Row>

                        <Row>
                            <Col md={6}>
                                <div style={{ textAlign: "left", marginBottom: "25px" }}>
                                    <Form.Label style={{ fontWeight: "bold", fontSize: "12px", color: "#666666" }}>Card Number (PAN)</Form.Label>
                                    <Form.Control
                                        type="text"
                                        value={formData.pan.replace(/(.{4})/g, '$1 ').trim()} // Automatically adds spaces visually
                                        name="pan"
                                        onChange={handleCardDetailsChange}
                                        placeholder="0000 0000 0000 0000"
                                        style={{ fontSize: "12px" }}
                                    />
                                    {error.pan && <div style={{ color: "red", fontSize: "12px" }}>{error.pan}</div>}
                                </div>
                            </Col>
                            <Col md={3}>
                                <div style={{ textAlign: "left", marginBottom: "25px" }}>
                                    <Form.Label style={{ fontWeight: "bold", fontSize: "12px", color: "#666666" }}>Expiry (MM/YY)</Form.Label>
                                    <Form.Control
                                        type="text"
                                        value={formData.exp}
                                        name="exp"
                                        onChange={handleCardDetailsChange}
                                        placeholder="MM/YY"
                                        style={{ fontSize: "12px" }}
                                    />
                                </div>
                            </Col>
                            <Col md={3}>
                                <div style={{ textAlign: "left", marginBottom: "25px" }}>
                                    <Form.Label style={{ fontWeight: "bold", fontSize: "12px", color: "#666666" }}>CVC</Form.Label>
                                    <Form.Control
                                        type="password"
                                        value={formData.cvc}
                                        name="cvc"
                                        onChange={handleCardDetailsChange}
                                        placeholder="•••"
                                        style={{ fontSize: "12px" }}
                                    />
                                </div>
                            </Col>
                        </Row>

                        {/* <Row>
                            <Col md={6}>
                                <div style={{ textAlign: "left", marginBottom: "25px" }}>
                                    <Form.Label style={{ fontWeight: "bold", fontSize: "12px", color: "#666666" }}>Card Number (PAN)</Form.Label>
                                    {/* <Form.Control type="text" value={formData.pan} name="pan" onChange={handleChange} style={{ fontSize: "12px" }} /> *
                                    <Form.Control
                                        type="text"
                                        value={formData.pan.replace(/(.{4})/g, '$1 ').trim()} // Formats "12345678" to "1234 5678"
                                        name="pan"
                                        disabled
                                        style={{ fontSize: "12px" }}
                                    />
                                </div>
                            </Col>
                            <Col md={3}>
                                <div style={{ textAlign: "left", marginBottom: "25px" }}>
                                    <Form.Label style={{ fontWeight: "bold", fontSize: "12px", color: "#666666" }}>Expiry (MM/YY)</Form.Label>
                                    <Form.Control type="text" value={formData.exp} name="exp" disabled style={{ fontSize: "12px" }} />
                                </div>
                            </Col>
                            <Col md={3}>
                                <div style={{ textAlign: "left", marginBottom: "25px" }}>
                                    <Form.Label style={{ fontWeight: "bold", fontSize: "12px", color: "#666666" }}>CVC</Form.Label>
                                    <Form.Control type="password" value={formData.cvc} name="cvc" disabled style={{ fontSize: "12px" }} />
                                </div>
                            </Col>
                        </Row> */}

                        <div style={{ display: 'flex', alignItems: 'center', marginTop: '10px' }}>
                            <Button
                                style={{
                                    backgroundColor: "#00a1be", borderColor: "#00a1be", color: "white",
                                    padding: "10px 25px", fontSize: "12px", fontWeight: "bold", textTransform: "uppercase",
                                }}
                                onClick={handleSubmitStep1}
                                disabled={loading}
                            >
                                {loading && !enrollmentData ? 'Initiating...' : 'Initiate Step 1'}
                            </Button>
                        </div>
                    </div>

                    {/* DYNAMIC STEP 2 & 3: EMBEDDED IFRAME */}
                    {enrollmentData && (
                        <div style={{ border: "2px solid #28a745", borderRadius: "5px", padding: "20px", margin: "20px 0", backgroundColor: "#f9fff9" }}>
                            <Row>
                                <Col>
                                    <div style={{ textAlign: "left", marginBottom: "20px" }}>
                                        <p style={{ fontWeight: "bold", fontSize: "24px", color: "#28a745" }}>
                                            2. Complete 3D Secure Challenge
                                        </p>
                                        <p style={{ fontSize: "14px", color: "#555" }}>
                                            Please complete the authentication with your bank below.
                                        </p>
                                    </div>
                                </Col>
                            </Row>

                            {/* THE EMBEDDED IFRAME */}
                            <Row className="mb-4">
                                <Col>
                                    <iframe
                                        name="acsIframe"
                                        title="3D Secure Authentication"
                                        style={{
                                            width: "100%",
                                            height: "500px",
                                            border: "1px solid #dee2e6",
                                            borderRadius: "4px",
                                            backgroundColor: "#ffffff"
                                        }}
                                    />
                                </Col>
                            </Row>

                            <Row>
                                <Col md={12}>
                                    <div style={{ textAlign: "left", marginBottom: "25px" }}>
                                        <Form.Label style={{ fontWeight: "bold", fontSize: "12px" }}>PARes Payload (Paste PARes Value below)</Form.Label>
                                        <Form.Control
                                            as="textarea"
                                            rows={2}
                                            value={step2Data.pares}
                                            name="pares"
                                            onChange={handleStep2Change}
                                            style={{ fontSize: "12px" }}
                                            placeholder="PARes Value.."
                                        />
                                    </div>
                                </Col>
                            </Row>

                            <div style={{ display: 'flex', alignItems: 'center' }}>
                                <Button
                                    style={{
                                        backgroundColor: "#28a745", borderColor: "#28a745", color: "white",
                                        padding: "10px 25px", fontSize: "12px", fontWeight: "bold", textTransform: "uppercase",
                                    }}
                                    onClick={handleSubmitStep3}
                                    disabled={loading}
                                >
                                    {loading ? 'Processing Final Auth...' : 'Execute Final Auth (Step 3)'}
                                </Button>
                            </div>
                        </div>
                    )}

                    {/* LOGS / RESPONSE SECTION */}
                    <div style={{ border: "1px solid #ccc", borderRadius: "5px", padding: "20px", margin: "20px 0" }}>
                        <Row>
                            <Col>
                                <div style={{ textAlign: "left", marginBottom: "30px" }}>
                                    <p style={{ fontWeight: "bold", fontSize: "24px", color: "#253370" }}>Logs & Result</p>
                                </div>
                            </Col>
                        </Row>

                        <Row>
                            <Col md={6}>
                                <div style={{ textAlign: "left", marginBottom: "25px" }}>
                                    <Form.Label style={{ fontWeight: "bold", fontSize: "14px" }}>Request Payload</Form.Label>
                                    <Form.Control as="textarea" rows={16} value={logRequest} readOnly style={{ fontSize: "12px", fontFamily: "Courier New, monospace", backgroundColor: "#f8f9fa" }} />
                                </div>
                            </Col>
                            <Col md={6}>
                                <div style={{ textAlign: "left", marginBottom: "25px" }}>
                                    <Form.Label style={{ fontWeight: "bold", fontSize: "14px" }}>API Response</Form.Label>
                                    <Form.Control as="textarea" rows={16} value={logResponse} readOnly style={{ fontSize: "12px", fontFamily: "Courier New, monospace", backgroundColor: "#f8f9fa" }} />
                                </div>
                            </Col>
                        </Row>
                    </div>
                </Container>
            </Container>
        </div>
    );
};

export default Latpay3dFlow;